import { render, staticRenderFns } from "./UserProfileEditPassword.vue?vue&type=template&id=62d8ee7a&"
import script from "./UserProfileEditPassword.vue?vue&type=script&lang=ts&"
export * from "./UserProfileEditPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports